import React from "react";
import Icon from "@mdi/react";
import {
	mdiMessageText,
	mdiMessageTextOutline,
	mdiToolbox,
	mdiToolboxOutline,
	mdiListBox,
	mdiListBoxOutline,
	mdiCalendarClock,
	mdiCalendarClockOutline,
	mdiAccountBox,
	mdiAccountBoxOutline,
} from "@mdi/js";
import styles from "./styles.module.scss";
import { Link } from "components";
import { clsx } from "@ismael1361/utils";

/**
 * BottomNav mobile (≤ 768px).
 *
 * Substitui o IconSidebar lateral em mobile. 5 icones fixos com label visivel
 * (padrao WhatsApp/Telegram/Instagram). Backoffice e Faturamento ficam fora
 * (rotas raras — usuario pode acessar via /settings → menu se precisar).
 *
 * Cuidados:
 * - safe-area-bottom respeitado p/ iPhone gesture bar
 * - Altura fixa 56px (referenciada em $bottom-nav-height do responsive.scss)
 * - Position: fixed bottom 0 — content tem padding-bottom equivalente
 */

interface NavItem {
	label: string;
	href: string;
	iconActive: string;
	iconInactive: string;
	isActive: () => boolean;
}

const navItems: NavItem[] = [
	{
		label: "Chat",
		href: "/",
		iconActive: mdiMessageText,
		iconInactive: mdiMessageTextOutline,
		isActive: () => window.location.pathname === "/" || /^\/team\//i.test(window.location.pathname),
	},
	{
		label: "Tools",
		href: "/tools",
		iconActive: mdiToolbox,
		iconInactive: mdiToolboxOutline,
		isActive: () => /^\/tools/i.test(window.location.pathname),
	},
	{
		label: "Tarefas",
		href: "/tasks",
		iconActive: mdiListBox,
		iconInactive: mdiListBoxOutline,
		isActive: () => /^\/tasks/i.test(window.location.pathname),
	},
	{
		label: "Agendas",
		href: "/scheduled-tasks",
		iconActive: mdiCalendarClock,
		iconInactive: mdiCalendarClockOutline,
		isActive: () => /^\/scheduled-tasks/i.test(window.location.pathname),
	},
	{
		label: "Perfil",
		href: "/settings",
		iconActive: mdiAccountBox,
		iconInactive: mdiAccountBoxOutline,
		isActive: () => /^\/settings/i.test(window.location.pathname),
	},
];

export const BottomNav: React.FC = () => {
	return (
		<nav className={styles.bottomNav} aria-label="Navegação principal">
			{navItems.map((item) => {
				const active = item.isActive();
				return (
					<Link
						key={item.href}
						href={item.href}
						className={clsx(styles.navItem, active && styles.active)}
						title={item.label}
					>
						<Icon path={active ? item.iconActive : item.iconInactive} size={1} />
						<span className={styles.navLabel}>{item.label}</span>
					</Link>
				);
			})}
		</nav>
	);
};
